// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sat-info-title {
  font-size: 22px !important;
  min-height: 25px;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 5px;
  text-align: center;
  background: var(--color-dark-border);
  color: var(--colorWhite);
  margin-bottom: 5px;
}

#sat-add-watchlist,
#sat-remove-watchlist {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

#sat-add-watchlist {
  filter: hue-rotate(275deg) brightness(1.2);
}

#sat-remove-watchlist {
  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(100%) contrast(86%);
}

.sat-info-section-header {
  height: 25px;
  font-size: 18px;
  text-align: center;
  background: var(--color-dark-border);
  color: var(--colorWhite);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-bottom: 5px;
  cursor: pointer;
}

#sat-infobox a {
  color: white;
}

.sat-info-row {
  margin-bottom: 3px;
  padding: 1px 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}

.sat-info-row:hover {
  background: rgba(0, 0, 0, 0.2);
}

#sat-site {
  max-height: 40px;
}

#sat-site-row {
  max-height: 40px;
}

.sat-info-key,
.sat-info-value {
  display: inline-block;
}

.sat-info-key {
  max-width: 75px;
  font-size: 12px;
  color: white;
  float: left;
}

.sat-infobox-links {
  font-size: small;
  padding: 2px 10px;
  color: var(--color-dark-text-accent);
}

.section-collapse {
  position: absolute;
  right: 0px;
  cursor: pointer;
  color: var(--color-dark-text-accent);
  width: 25px;
  height: 25px;
}

.section-collapse:hover {
  background-color: var(--color-dark-text-accent);
  color: white;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.section-collapse:active {
  background-color: var(--color-primary-dark);
  color: white;
  scale: 0.9;
}

#search-links {
  margin-top: 5px;
}

.sat-info-section,
#sat-identifier-data,
#orbital-section,
#secondary-sat-info,
#sensor-sat-info,
#sat-mission-data {
  transition: max-height 0.5s ease-in-out;
  max-height: 1000px;
  /* Set this to a value larger than the content's height */
  overflow: hidden;
  margin: 5px 0px;
}

.sat-info-section.collapsed,
#sat-identifier-data.collapsed,
#orbital-section.collapsed,
#secondary-sat-info.collapsed,
#sensor-sat-info.collapsed,
#sat-mission-data.collapsed {
  max-height: 25px;
  transition: max-height 0.2s ease-in-out;
  margin: 5px 0px;
}

#sat-infobox {
  display: none;
  position: absolute;
  background: var(--color-dark-background);
  cursor: default;
  bottom: 0px;
  height: fit-content;
  max-height: 30%;
  width: 100%;
  border: 5px solid var(--color-dark-border);
  overflow: auto;
  z-index: 10000;
}

.sat-info-value {
  float: right;
  width: 45%;
  min-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/plugins/sat-info-box/sat-info-box.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,uCAAuC;EACvC,kBAAkB;EAClB,yDAAyD;EACzD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,0CAA0C;EAC1C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["#sat-info-title {\n  font-size: 22px !important;\n  min-height: 25px;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n  padding-bottom: 5px;\n  text-align: center;\n  background: var(--color-dark-border);\n  color: var(--colorWhite);\n  margin-bottom: 5px;\n}\n\n#sat-add-watchlist,\n#sat-remove-watchlist {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n\n#sat-add-watchlist {\n  filter: hue-rotate(275deg) brightness(1.2);\n}\n\n#sat-remove-watchlist {\n  filter: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(100%) contrast(86%);\n}\n\n.sat-info-section-header {\n  height: 25px;\n  font-size: 18px;\n  text-align: center;\n  background: var(--color-dark-border);\n  color: var(--colorWhite);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-bottom: 5px;\n  cursor: pointer;\n}\n\n#sat-infobox a {\n  color: white;\n}\n\n.sat-info-row {\n  margin-bottom: 3px;\n  padding: 1px 10px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sat-info-row:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n#sat-site {\n  max-height: 40px;\n}\n\n#sat-site-row {\n  max-height: 40px;\n}\n\n.sat-info-key,\n.sat-info-value {\n  display: inline-block;\n}\n\n.sat-info-key {\n  max-width: 75px;\n  font-size: 12px;\n  color: white;\n  float: left;\n}\n\n.sat-infobox-links {\n  font-size: small;\n  padding: 2px 10px;\n  color: var(--color-dark-text-accent);\n}\n\n.section-collapse {\n  position: absolute;\n  right: 0px;\n  cursor: pointer;\n  color: var(--color-dark-text-accent);\n  width: 25px;\n  height: 25px;\n}\n\n.section-collapse:hover {\n  background-color: var(--color-dark-text-accent);\n  color: white;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.section-collapse:active {\n  background-color: var(--color-primary-dark);\n  color: white;\n  scale: 0.9;\n}\n\n#search-links {\n  margin-top: 5px;\n}\n\n.sat-info-section,\n#sat-identifier-data,\n#orbital-section,\n#secondary-sat-info,\n#sensor-sat-info,\n#sat-mission-data {\n  transition: max-height 0.5s ease-in-out;\n  max-height: 1000px;\n  /* Set this to a value larger than the content's height */\n  overflow: hidden;\n  margin: 5px 0px;\n}\n\n.sat-info-section.collapsed,\n#sat-identifier-data.collapsed,\n#orbital-section.collapsed,\n#secondary-sat-info.collapsed,\n#sensor-sat-info.collapsed,\n#sat-mission-data.collapsed {\n  max-height: 25px;\n  transition: max-height 0.2s ease-in-out;\n  margin: 5px 0px;\n}\n\n#sat-infobox {\n  display: none;\n  position: absolute;\n  background: var(--color-dark-background);\n  cursor: default;\n  bottom: 0px;\n  height: fit-content;\n  max-height: 30%;\n  width: 100%;\n  border: 5px solid var(--color-dark-border);\n  overflow: auto;\n  z-index: 10000;\n}\n\n.sat-info-value {\n  float: right;\n  width: 45%;\n  min-height: 20px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
